import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-find-route-form',
  templateUrl: './find-route-form.component.html',
  styleUrls: ['./find-route-form.component.scss']
})
export class FindRouteFormComponent implements OnDestroy {
  @Output() readonly selected: EventEmitter<any> = new EventEmitter();
  private destroy$ = new Subject<void>();
  private lastSearched: string | null = null;
  selectedLineKppIds: number[] | null = null;

  readonly form = new FormGroup({
    carrier: new FormControl(null, Validators.required),
    line: new FormControl(null, Validators.required),
    direction: new FormControl(null, Validators.required)
  });

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  @Input()
  set patchRouteQuery(q: RouteQuery | null) {
    if (q != null) {
      this.form.patchValue({
        carrier: q.carrierId,
        line: q.line,
        direction: q.direction
      });
      this.onSubmit();
    } else
      this.handleFormClear();
  }


  onSubmit(): void {
    const fV = this.form.value;
    this.lastSearched = JSON.stringify(fV);
    const q = new RouteQuery(fV.carrier, fV.line, fV.direction);
    this.selected.next(q);
  }

  handleFormClear(): void {
    this.form.reset();
    this.selected.next(null);
  }

  get hasChanged(): boolean {
    return JSON.stringify(this.form.value) !== this.lastSearched;
  }

}

export class RouteQuery {
  constructor(public readonly carrierId: number, public readonly line: string, public readonly direction: string) { }
}
